import { useCurationAdditionalServicesSaveMutation } from "@/features/experience-curation/mutations/useCurationAdditionalServicesSaveMutation";
import { useCurationHighlightsSaveMutation } from "@/features/experience-curation/mutations/useCurationHighlightsSaveMutation";
import { useCurationTranslationsSaveMutation } from "@/features/experience-curation/mutations/useCurationTranslationsSaveMutation";
import { useCurationCategoriesSaveMutation } from "@/features/experience-curation/mutations/useCurationCategoriesSaveMutation";
import { useSaveLocationMutation } from "@/features/experience-curation/mutations/useSaveLocationMutation";
import { useSaveAdditionalCitiesMutation } from "@/features/experience-curation/mutations/useSaveAdditionalCitiesMutation";
import { useSaveVenuesMutation } from "@/features/experience-curation/mutations/useSaveVenuesMutation";
import { useCurationBookingInfoSaveMutation } from "@/features/experience-curation/mutations/useCurationBookingInfoSaveMutation";
import { useOperationalTranslationsSaveMutation } from "@/features/experience-curation/mutations/useOperationalTranslationsSaveMutation";

export function useCurationMutations() {
  return [
    useCurationAdditionalServicesSaveMutation(),
    useCurationHighlightsSaveMutation(),
    useCurationTranslationsSaveMutation(),
    useCurationCategoriesSaveMutation(),
    useSaveLocationMutation(),
    useSaveAdditionalCitiesMutation(),
    useSaveVenuesMutation(),
    useCurationBookingInfoSaveMutation(),
    useOperationalTranslationsSaveMutation(),
  ];
}
